



























import Cookies from 'js-cookie';
import {
  Component, Vue, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { AuthorizationStore, MyaaffiliateStore, Payload } from '@/state/modules';
import { _isEmpty } from '@/plugins/lodash';
import { AUTH_TOKEN, CURRENT_USER_LANG } from '@/utils/localstorage-util';

class FormData {
  newPass: string = ''

  confirmPassword: string = ''
}
class UpdatePasswordState {
      public formData: FormData = new FormData()
}

    @Component({
      /**
         * Imported components
         * */
      components: {},
      /**
         * Stores values
         * */
      computed: {},
      /**
         * Component properties
         * */
      props: {},
    })
export default class UpdatePassword extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new UpdatePasswordState();

        /**
         * Watchers
         * */
        @Watch('ifLocaleChange', { immediate: true })
        localeChanges() {
          this.rules = {
            newPass: [
              { required: true, message: this.$t('update_info.err_enter_password').toString(), trigger: 'blur' },
              { min: 8, message: this.$t('update_info.err_pass_min').toString(), trigger: 'blur' },
              { max: 20, message: this.$t('update_info.err_pass_max').toString(), trigger: 'blur' },
            ],
            confirmPassword: [
              { required: true, validator: this.confirmPass, trigger: 'blur' },
            ],
          };
        }

      rules = {}

      /**
         * Methods
         * */
      updatePassword() {
        this.$refs.passwordForm.validate((valid) => {
          if (valid) {
            const affToken = `Bearer ${this.$route.query.token}`;
            AuthorizationStore.getMyInfo(new Payload({ token: affToken })).then((response) => {
              const affInfo = response.data;
              if (affInfo.request_email === false) {
                this.showAlert(this.$t('api_error.prompt_saving').toString(), this.$data.SamclickAlert.WARNING, false).then(() => {
                  MyaaffiliateStore.updatePassword(new Payload({ password: this.state.formData.newPass, request_email: true })).then((response) => {
                    this.showAlert(this.$t('api_error.prompt_updated_ok').toString(), this.$data.SamclickAlert.SUCCESS);
                    this.state = new UpdatePasswordState();
                    Cookies.remove(AUTH_TOKEN);
                  }, (error) => {
                    if (error.status === 400 && error.data && error.data.detail) {
                      this.showAlert(
                        this.$t(error.data.detail).toString(),
                        this.$data.SamclickAlert.ERROR,
                      );
                    } else {
                      this.showAlert('ERROR', this.$data.SamclickAlert.ERROR);
                    }
                  });
                }).catch(() => {
                });
              }
            });
          }
        });
      }

      confirmPass(rule: any, value: any, callback: any) {
        if (!value) {
          return callback(new Error(this.$t('update_info.err_password_confirm').toString()));
        }
        if (this.state.formData.newPass && this.state.formData.confirmPassword && this.state.formData.newPass.toLowerCase() !== this.state.formData.confirmPassword.toLowerCase()) {
          return callback(new Error(this.$t('update_info.err_pass_not_match').toString()));
        }
        return callback();
      }

      backToTop() {
        this.state = new UpdatePasswordState();
        this.$router.push({ name: 'login' });
      }


      /**
         * Computed
         * */
      get computedVal() {
        return {};
      }

      /**
         * Lifecycle hooks
         * */
      created() {
      }

      mounted() {
        if (!_isEmpty(this.$route.query) && this.$route.query.token) {
          const affToken = `Bearer ${this.$route.query.token}`;
          Cookies.set(AUTH_TOKEN, affToken);
          AuthorizationStore.getMyInfo(new Payload({ token: affToken })).then((response) => {
            const affInfo = response.data;
            const selectedLang = affInfo.preferred_language;
            window.localStorage.setItem(CURRENT_USER_LANG, selectedLang);
            this.$i18n.i18next.changeLanguage(selectedLang);
            if (affInfo.request_email === true) {
              this.$router.push({ name: 'login' });
            }
          }).catch((response) => {
            if (response.status === 400 && response.data.detail === 'invalid_email') {
              AuthorizationStore.logout();
              this.$router.push({ name: 'login' });
            }
          });
        }
      }

      beforeUpdate() {
      }
}
